class MobileDetectionService {
  private static get isBrowser(): boolean {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
  }

  private static get userAgent(): string {
    return this.isBrowser ? navigator.userAgent : '';
  }

  private static matches(regex: RegExp): boolean {
    return this.isBrowser && regex.test(this.userAgent);
  }

  private static get nav(): Navigator | undefined {
    return typeof navigator === 'undefined' ? undefined : navigator;
  }

  public static isAndroid(): boolean {
    return this.matches(/android/i);
  }

  public static isIOS(): boolean {
    if (!this.isBrowser) {
      return false;
    }

    return (
      /ipad|iphone|ipod/i.test(this.userAgent) ||
      ((this.nav?.maxTouchPoints ?? 0) > 2 && /macintel|macintosh/i.test(this.userAgent))
    );
  }

  public static isSafari(): boolean {
    return this.matches(/safari/i) && !this.matches(/chrome|chromium|android|fxios|edg/i);
  }

  public static isChrome(): boolean {
    return this.matches(/chrome|crios/i) && !this.matches(/edg|opr/i);
  }

  public static isFirefox(): boolean {
    return this.matches(/firefox|fxios/i);
  }

  public static getBrowser(): string {
    if (this.isChrome()) {
      return 'Chrome';
    }
    if (this.isSafari()) {
      return 'Safari';
    }
    if (this.isFirefox()) {
      return 'Firefox';
    }

    return 'Other';
  }

  public static getOperatingSystem(): string {
    if (this.isIOS()) {
      return 'iOS';
    }
    if (this.isAndroid()) {
      return 'Android';
    }
    return 'Other';
  }
}

export default MobileDetectionService;
